import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import UnitList from '../pages/Units/UnitList'
import {PageTitle} from '../../_metronic/layout/core'
import AddUnit from '../pages/Units/AddUnit'
import ModuleList from '../pages/modules/ModuleList'
import AddModule from '../pages/modules/AddModule'
import SubscriptionList from '../pages/subscriptions/SubscriptionList'
import AddSubscription from '../pages/subscriptions/AddSubscription'
import CohortList from '../pages/cohort/CohortList'
import AddCohort from '../pages/cohort/AddCohort'
import LanguageList from '../pages/languages/LanguageList'
import AddLanguage from '../pages/languages/AddLanguage'
import {PreviewUnit} from '../pages/Units/PreviewUnit'
import {PreviewModule} from '../pages/modules/PreviewModule'
import UserList from '../pages/user/UserList'
import CategoryList from '../pages/category/CategoryList'
import CourseList from '../pages/courses/CourseList'
import AddCourse from '../pages/courses/AddCourse'
import {PreviewCourse} from '../pages/courses/preview-course'
import ProgramList from '../pages/programs/ProgramList'
import AddProgram from '../pages/programs/AddProgram'
import {PreviewProgram} from '../pages/programs/Preview-Program'
import VideoList from '../pages/videos/VideoList'
import AddVideo from '../pages/videos/AddVideo'
import FaqList from '../pages/faqs/FAQList'
import AddFAQ from '../pages/faqs/AddFAQ'
import ScheduleList from '../pages/livestream/ScheduleList'
import AddSchedule from '../pages/livestream/AddSchedule'
import AnnouncementT from '../pages/announcement-type/AnnouncementTypeList'
import AddAnnouncementType from '../pages/announcement-type/AddAnnouncementType'
import AnnouncementList from '../pages/announcements/AnnouncementList'
import AddAnouncement from '../pages/announcements/AddAnouncement'
import {ViewUser} from '../pages/user/ViewUser'
import { Settings } from '../pages/settings/Settings'


const PrivateRoutes = () => {
  // const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  // const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  // const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  //  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  // const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  // const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        {/* <Route path='builder' element={<BuilderPageWrapper />} /> */}

        <Route path='menu-test' element={<MenuTestPage />} />


        <Route
          path='unitlist/preview-unit'
          element={
            <>
              <PageTitle>Preview Unit</PageTitle>
              <PreviewUnit className='mb-5 py-5 px-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='courselist/preview-course'
          element={
            <>
              <PageTitle>Preview Course</PageTitle>
              <PreviewCourse className='mb-5 py-5 px-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='/programlist/preview-program'
          element={
            <>
              <PageTitle>Preview Program</PageTitle>
              <PreviewProgram className='mb-5 py-5 px-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='modulelist/preview-module'
          element={
            <>
              <PageTitle>Preview Module</PageTitle>
              <PreviewModule className='mb-5 py-5 px-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='unitlist'
          element={
            <>
              <PageTitle>Unit List</PageTitle>
              <UnitList className='mb-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='announcement-types'
          element={
            <>
              <PageTitle>Announcement Types</PageTitle>
              <AnnouncementT className='mb-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='announcement-types/addannouncementtype'
          element={
            <>
              <PageTitle>Add Announcement Type</PageTitle>
              <AddAnnouncementType />
            </>
          }
        />

<Route
          path='announcement-types/editannouncementtype'
          element={
            <>
              <PageTitle>Edit Announcement Type</PageTitle>
              <AddAnnouncementType />
            </>
          }
        />

        <Route
          path='schedulelist'
          element={
            <>
              <PageTitle>Live Stream</PageTitle>
              <ScheduleList className='mb-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='faqlist'
          element={
            <>
              <PageTitle>FAQs List</PageTitle>
              <FaqList className='mb-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='userlist'
          element={
            <>
              <PageTitle>User List</PageTitle>
              <UserList className='mb-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='userlist/viewuser'
          element={
            <>
              <PageTitle>View User</PageTitle>
              <ViewUser className='mb-5 py-5 px-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='videolist'
          element={
            <>
              <PageTitle>Video List</PageTitle>
              <VideoList className='mb-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='settings'
          element={
            <>
              <PageTitle>Settings</PageTitle>
              <Settings />
            </>
          }
        />

        <Route
          path='languagelist'
          element={
            <>
              <PageTitle>Language List</PageTitle>
              <LanguageList className='mb-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='announcementlist'
          element={
            <>
              <PageTitle>Announcement List</PageTitle>
              <AnnouncementList className='mb-5 mb-xl-8' />
            </>
          }
        />
        

        <Route
          path='announcementlist/addannouncement'
          element={
            <>
              <PageTitle>Add Announcement</PageTitle>
              <AddAnouncement />
            </>
          }
        />

<Route
          path='announcementlist/editannouncement'
          element={
            <>
              <PageTitle>Edit Announcement</PageTitle>
              <AddAnouncement />
            </>
          }
        />

        <Route
          path='category'
          element={
            <>
              <PageTitle>Add Category</PageTitle>
              <CategoryList className='mb-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='faqlist/addfaq'
          element={
            <>
              <PageTitle>Add FAQ</PageTitle>
              <AddFAQ />
            </>
          }
        />
         <Route
          path='faqlist/editfaq'
          element={
            <>
              <PageTitle>edit FAQ</PageTitle>
              <AddFAQ />
            </>
          }
        />

        <Route
          path='schedulelist/addschedule'
          element={
            <>
              <PageTitle>Add New Live Stream Class</PageTitle>
              <AddSchedule />
            </>
          }
        />
        <Route
          path='schedulelist/editschedule'
          element={
            <>
              <PageTitle>Edit Live Stream Class</PageTitle>
              <AddSchedule />
            </>
          }
        />

        <Route
          path='modulelist'
          element={
            <>
              <PageTitle>Module List</PageTitle>
              <ModuleList className='mb-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='programlist'
          element={
            <>
              <PageTitle>Program List</PageTitle>
              <ProgramList className='mb-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='subscriptionlist'
          element={
            <>
              <PageTitle>Subscription List</PageTitle>
              <SubscriptionList className='mb-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='cohortlist'
          element={
            <>
              <PageTitle>Cohort List</PageTitle>
              <CohortList className='mb-5 mb-xl-8' />
            </>
          }
        />

        <Route
          path='courselist'
          element={
            <>
              <PageTitle>Course List</PageTitle>
              <CourseList className='mb-5 mb-xl-8' />
            </>
          }
        />
        <Route
          path='courselist/addcourse'
          element={
            <>
              <PageTitle>Add course</PageTitle>
              <AddCourse />
            </>
          }
        />

<Route
          path='courselist/editcourse'
          element={
            <>
              <PageTitle>Edit course</PageTitle>
              <AddCourse />
            </>
          }
        />

        <Route
          path='subscriptionlist/addsubscription'
          element={
            <>
              <PageTitle>Add Subscription</PageTitle>
              <AddSubscription />
            </>
          }
        />
          <Route
          path='subscriptionlist/editsubscription'
          element={
            <>
              <PageTitle>Edit Subscription</PageTitle>
              <AddSubscription />
            </>
          }
        />


        <Route
          path='languagelist/addlanguage'
          element={
            <>
              <PageTitle>Add Language</PageTitle>
              <AddLanguage />
            </>
          }
        />

        <Route
          path='unitlist/addunit'
          element={
            <>
              <PageTitle>Add Unit</PageTitle>
              <AddUnit />
            </>
          }
        />

        <Route
          path='unitlist/editunit'
          element={
            <>
              <PageTitle>Edit Unit</PageTitle>
              <AddUnit />
            </>
          }
        />

        <Route
          path='modulelist/addmodule'
          element={
            <>
              <PageTitle>Add Module</PageTitle>
              <AddModule />
            </>
          }
        />
           <Route
          path='modulelist/editmodule'
          element={
            <>
              <PageTitle>Edit Module</PageTitle>
              <AddModule />
            </>
          }
        />

        <Route
          path='cohortlist/addcohort'
          element={
            <>
              <PageTitle>Add Cohort</PageTitle>
              <AddCohort />
            </>
          }
        />

        <Route
          path='programlist/addProgram'
          element={
            <>
              <PageTitle>Add Program</PageTitle>
              <AddProgram />
            </>
          }
        />

<Route
          path='programlist/editProgram'
          element={
            <>
              <PageTitle>Edit Program</PageTitle>
              <AddProgram />
            </>
          }
        />

        <Route
          path='videolist/addvideo'
          element={
            <>
              <PageTitle>Add Video</PageTitle>
              <AddVideo />
            </>
          }
        />
        <Route
          path='videolist/editvideo'
          element={
            <>
              <PageTitle>Edit Video</PageTitle>
              <AddVideo />
            </>
          }
        />

        {/* Lazy Modules */}
        {/* <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        {/* <Route
          path='unitlist/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        /> */}
        {/* <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        /> */}
        {/* <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        /> */}
        {/* <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />  */}
        {/* Page Not Found */}
        {/* <Route path='*' element={<Navigate to='/error/404' />} /> */}
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
